import React from 'react';
import '../assets/css/Totd.css';

const About = () => {
  return (
    <div className="container">
      <section className="ctext section-body" id="about" data-rv-view="0">
        <div className="filter-container">
          <div className="container">
            <div className="row">
              <div className="totdText">
                <h3>About RippaDay</h3>
                <p>RippaDay provides daily racing tips, member selections, and racing tools for people who enjoy following horse racing.</p>
                <p>Information on RippaDay is provided for entertainment and informational purposes only. RippaDay does not take bets, operate wagering accounts, or guarantee any result.</p>

                <h4>What is Dutch betting?</h4>
                <p>Dutch betting, or Dutching, is the practice of backing more than one selection to target a similar profit regardless of which selected runner wins. RippaDay includes tools that can help calculate stake splits for this style of betting.</p>

                <h4>Responsible gambling</h4>
                <p>Only use racing and betting-related information if you are legally allowed to do so in your location. Gamble responsibly. Australian users can visit <a href="https://www.gamblinghelponline.org.au/">Gambling Help Online</a> for support.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
